$(document).on('guestview', function () {
    $('#guestinfo').remove();

    if ( !!$('.uppprivate').length) {

        $('#uppcontent article').hide();
        $('#ppnav, .ptab, .dashboard .guesthide').fadeOut(300);
        $('#uppcontent').after(guestinfo);

        setTimeout(function() {
            $('.status-bar .fill')
                .css({'width':'0px'})
                .html('');
            $('#ledger').html('');
            $('#points-ledger tbody').html('');
        },500);

    }
    else {
        setTimeout(function() {
            $('#uppcontent').fadeTo(300,1);
            _ppprotect.fadeTo(300,1);
        },250);

        var passedevent = getUrlParam('event');
        if(passedevent && $('#updates-guest').length ) {
            $('#updates-guest').fadeIn(300);
        }
    }
});

$(document).on('maintenance', function () {
    if ( !!$('#uppcontent').length) {
        //$(document).trigger('logged-out');
        showResult(_maintenance, 'warning');
        showResult(_maintenance, 'warning');
    }
});

function lostPost() {
    _lost.validate({
        submitHandler: function(form) {
            lostPassword(form);
        }
    });
}

function lostPassword() {
    var email = $('#main #lostemail').val();
    var locale = $('#locale').val();

    return passport.sendReset(email, upp_page.reset_password, upp_page.signup, locale)
    .fail(function(jqXHR, textStatus, error){
        $(document).trigger('rebuild');
        if (jqXHR.status == 401) {
            //$(document).trigger('logged-out');
            showResult(_error, 'error');
        } else if (jqXHR.status == 409) {
            showResult(errors.duplicateemail, 'error');
        } else {
            showResult(errors.general, 'error');
        }
    })
    .done(function(data, textStatus, jqXHR){
        if (jqXHR.status == 401) {
            showResult(errors.general, 'error');
        } else {
            showResult(_passwordresetsent, 'success', { duration: 4000 });
        }

        $(document).trigger('rebuild');

    })

}

function resetPost() {
    _reset.validate({
        rules: {
            newpassword: {
                required: true,
                minlength: 8
            }
        },
        messages: {
            newpassword: {
                minlength: errors.password
            }
        },
        showErrors: function(errorMap, errorList) {
            $.each(errorList, function() {
                showResult(this.message, 'error');
            });
            this.defaultShowErrors();
        },
        submitHandler: function(form) {
            resetPassword(form);
        }
    });

}

function resetPassword(form) {
    let form_data = Object.fromEntries(new FormData(form).entries());

    let token = form_data.token;
    let email = form_data.updateemail;
    let password = form_data.newpassword;
    let locale = form_data.locale;

    return passport.processReset(token, email, password, upp_page.dashboard, locale)
    .fail(function(jqXHR, textStatus, error){
        $(document).trigger('rebuild');
        if (jqXHR.status == 401) {
                  //$(document).trigger('logged-out');
                  showResult(errors.general, 'error');
              } else if (jqXHR.status == 409) {
                  showResult(errors.duplicateemail, 'error');
              } else {
                  showResult(errors.reset, 'error');
              }
          })
    .done(function(data, textStatus, jqXHR){
        showResult(_passwordresetsuccess, 'success', { duration: 8000 });
        $('#password').val('');
        $('#email').val('');

        uppLogin(email, password).always(function () {
            passportRedirect();
        });
    });
}



function loginPost(data) {
    _login.validate({
        submitHandler: function(form) {
            login(form);
        }
    });
}

function login(form) {
    let form_data = Object.fromEntries(new FormData(form).entries());

    uppLogin(form_data.loginemail, form_data.loginpassword)
    .done(function () {
        passportRedirect();
    });
}

function uppLogin(email,password) {
    hideResult();
    return passport.login(email,password)
    .fail(function(jqXHR, textStatus, error){
        $(document).trigger('rebuild');
        if (jqXHR.status == 401) {
                    //$(document).trigger('logged-out');
                    showResult(errors.loginfail, 'error');
                } else if (jqXHR.status == 409) {
                    showResult(errors.duplicateemail, 'error');
                } else {
                    showResult(errors.general, 'error');
                }
            })
    .done(function(data, textStatus, jqXHR){
        setTimeout(function(){
            showResult(_signedin, 'success');
        }, 50);

        $(document).trigger('rebuild');
    });
}

$(document).on('click', '.upplogout', function(e){
    e.preventDefault();
    setTimeout(function(){
        passport.logout()
            .always(function(){
                $(document)
                    .trigger('logged-out')
                    .trigger('rebuild');
            });
    }, 300);
});

$(document).on('logged-in', function(event,passport){
    // always fade in uppcontent wrapper on logged in
    setTimeout(function() { $('#uppcontent').fadeTo(300,1); },250);
    if ( !! $('#guestinfo').length) {
        $('#guestinfo').remove();
    }

    $('#upp-header:not(.logged-in)')
        .addClass('logged-in')
        .removeClass('logged-out')
        .hide()
        .html(`<ul>${header_html}</ul>`)
        .delay(100)
        .fadeIn(300);

    $('#upp-footer:not(.logged-in)')
        .addClass('logged-in')
        .removeClass('logged-out')
        .hide()
        .html(`<ul>${footer_html}</ul>`)
        .delay(100)
        .fadeIn(300);

    fillData(passport);

    var newnavs = $('#upp-header>ul').html();

    $('#mnav-main').find('.upplink').remove();

    if(typeof(newnavs) != 'undefined' && newnavs != null ) {
        newnavs = newnavs.replace('Account','<strong>'+_myaccount+'</strong>');
        newnavs = newnavs.replace('Sign Out',`<strong><span class="fas fa-left fa-2xs"></span> ${_signout}</strong>`);
        $('#mnav-main').append(newnavs);

        $('#mnav-main li>a.dashboardbtn').parent().before(`<li class="upplink"><div class="lbreak3 op50" style="position:relative; top:10px;"></div><a><img width="100" alt="Ultra Passport" src="${upp_assets.images.logo}"></a></li>`);
        $('#mnav-main li>a.dashboardbtn').parent().before(`<li class="upplink"><a href="${upp_page.events}">Events</a></li>`);
        $('#mnav-main li>a.dashboardbtn').parent().before(`<li class="upplink"><a href="${upp_page.updates}">Updates</a></li>`);
    }

    $('#mnav .tiny-hide').removeClass('tiny-hide');

    $('#subscriptions.guest').removeClass('guest');
    $('#all-events.guest').removeClass('guest');
    $('#allbtns').removeClass('hide');
    $('#uppcontent, #uppcontent article').fadeIn(300);
    $('#pp-footer .fdates .ppstart').hide();

    if( !!$('.pphome').length ) {
        window.location.href = upp_page.dashboard;
    }

    if ( !! $('#guest-activate').length) {
        if ( passport.wristbands.length ) {
            window.location.href = ultra_settings.site_url + '/activate/form';
        }
    }

    setTimeout(function() {
        modalClose('#updates-guest');
        if(registration_notice || local_registration) {
            let alreadyregistered = _.some(passport.registrations, function(registration) {
                return registration.code === regcode;
            });

            if(!alreadyregistered && !_verify.length) {
                showResult($('#all-events').length ? _globalnotice2 : _globalnotice, 'info');
            }
        }
    }, 500);
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        'event': 'setUserID',
        'userID': String(passport.id),
        'user_id': String(passport.id)
    });

    $('body')
        .removeClass('upp-guest upp-pending upp-active')
        .addClass(passport.status === 'active' ? 'upp-active' : 'upp-pending');

    $(document).trigger('after-login');
});

$(document).on('after-login', function() {
    // If we're on the zoho desk login page, get a zoho desk token and redirect back to zoho desk with the provided serviceurl.
    let serviceUrl = getUrlParam('serviceurl');
    if (serviceUrl) {
        console.log(passport.generateZohoDeskToken(serviceUrl));
    }

    let redirect = getUrlParam('redirect');
    if (redirect) {
        passportRedirect();
    }
})

$(document).on('logged-out', function(){
    if(local_registration) {
        if( $('#all-events').length) {
            showResult(_globalnotice2, 'info');
        } else {
            showResult(_globalnotice, 'info');
        }
    }

    $('body')
        .removeClass('upp-pending upp-active')
        .addClass('upp-guest');

    _allevents
        .addClass('guest')
        .find('a.confirm').remove();

    $('#upp-header:not(.logged-out)')
        .removeClass('logged-in')
        .addClass('logged-out')
        .hide()
        .html(`<ul>${header_html_guest}</ul>`)
        .delay(100)
        .fadeIn(300);

    $('#upp-footer:not(.logged-out)')
        .removeClass('logged-in')
        .addClass('logged-out')
        .hide()
        .html(`<ul>${footer_html_guest}</ul>`)
        .delay(100)
        .fadeIn(300);

    $('.ppf form').on('submit', function(e) {
        e.preventDefault();
    }).validate({
        submitHandler: function(form) {
            leadForm(form);
        }
    });

    var newnavs = $('#upp-header>ul').html();

    $('#mnav-main').find('.upplink').remove();

    if(typeof(newnavs) != 'undefined' && newnavs != null ) {
        $('#mnav-main').append(newnavs);
        $('#mnav-main .upplink>ul').remove();
        $('#mnav-main li.signupm').before(`<li class="upplink"><div class="lbreak3 op50" style="position:relative; top:10px;"></div><a><img width="100" alt="Ultra Passport" src="${upp_assets.images.logo}"></a></li>`);
        $('#mnav-main li.signupm').before(`<li class="upplink"><a href="${upp_page.events}">Events</a></li>`);
        $('#mnav-main li.signupm').before(`<li class="upplink"><a href="${upp_page.updates}">Updates</a></li>`);
        $('#mnav-main li.signupm').find('a').wrapInner('<strong>');
        $('#mnav-main li.loginh').find('a').wrapInner('<strong>');
    }

    $('#pp-footer .fdates .ppstart').show();

    $('#all-events')
        .removeClass('pending')
        .addClass('guest');

    $('#subscriptions').addClass('guest');
    $('#allbtns').addClass('hide');
    $('#dashboard').fadeOut(300);

    $('.pending-text, .register-text').hide();
    $('.guest-text').show();

    setTimeout(function() {
        if(registration_notice) {
            if( $('#all-events').length || $('#tickets-app').length ) {
                showResult(_globalnotice2, 'info');
            }

            if( $('#manage-updates').length || $('.home-slider').length ) {
                showResult(_globalnotice, 'info');
            }
        }
    }, 500);

    if ( !! $('#activate-form').length) {
        showResult('You must have an Ultra Passport account in order to activate your wristband.', 'info');
        $('#activate-form').find('.guest').slideDown(300);
        $('#activate-form').find('ol').slideUp(300);
        $('#successbtn').remove();
    }
});


function leadForm() {
    //var email = $('#emailaddress').val();

    //$('#upp-footer form button').addClass('working');
    //$('#upp-footer form input').slideUp(300);

    $('.signupm>a').trigger('click');
    //$('#email').val(email);
    //setTimeout(function(){
      //document.location.href = (upp_page.signup+'/?e='+email);
  //}, 2000);

/*
  passport.sendLead(email,'unknown',null, ultra_settings.site_url)
    .fail(function(jqXHR, textStatus, error){
        $(document).trigger('rebuild');
        if (jqXHR.status == 401) {
          //$(document).trigger('logged-out');
          showResult('Error', 'error');
        } else if (jqXHR.status == 409) {
          showResult('Duplicate Email', 'error');
        } else {
          showResult('Something went wrong.', 'error');
        }
    })
    .done(function(data, textStatus, jqXHR){

      $('#upp-footer form button').addClass('working');
      $('#upp-footer form input').slideUp(300);

      setTimeout(function(){
        document.location.href = (upp_page.signup+'/?e='+email);
      }, 2000);

  })*/

}
